import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { VideoAnalyticsSolutionBG } from "../../constant";

export default function VideoAnalyticsLanding() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "80vh" },
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh", // Use dvh for mobile browsers
          minHeight: "-webkit-fill-available", // Better mobile support
          zIndex: -1,
          overflow: "hidden",
          pointerEvents: "none",
          background: "black",
          "::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          },
        }}
      >
        <video
          autoPlay
          loop
          muted
           playsInline
  preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            transform: "scaleX(-1)",
            filter: "brightness(0.5)",
            minHeight: "-webkit-fill-available",
          }}
        >
          <source src={VideoAnalyticsSolutionBG} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          margin: "0 auto",
          alignItems: "center",
        }}
      >
        {/* Title Box */}
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "1200px",
            textAlign: "center",
            py: 4,
            mt: 4,
          }}
        >
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={12} lg={12}>
              <Typography
                variant="h2"
                sx={{
                  background: 'linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)',
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "24px", sm: "32px", md: "48px" },
                  fontWeight: 700,
                  mb: 2,
                  textAlign: "center",
                  letterSpacing: isMobile ? "0px" : "-2.4px",
                  display: "flex",
                  justifyContent: "center",
                  width: isMobile ? "100%" : "60%",
                  margin: '0 auto'
                }}
              >
                {`Revolutionize Industrial Safety with LUNE Video Analytics`}
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: 1.8,
                  textAlign: "center",
                  margin: "40px auto 0",
                  width: isMobile ? "100%" : "60%",
                }}
              >
{"LUNE transforms surveillance systems into intelligent operational monitoring platforms with real-time AI-driven video analytics, proactive safety alerts, and actionable industrial insights. Detect PPE violations, unauthorized access, unsafe worker behavior, vehicle movement anomalies, and critical operational events instantly — enabling faster response, improved compliance, and smarter industrial decision-making."}              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
